const imageUrl = process.env.PUBLIC_URL + "/assets/images/";

export const common = { imageUrl };
